// extracted by mini-css-extract-plugin
export var chevron = "_j3-2";
export var dropdownItems = "_j3-0";
export var item = "_j3-1";